export const createSyncCheckHandler = ({
  syncCheck,
  authId,
  checkId,
  onClose,
  setErrorPopUp,
}) => () => {
  if (!authId || !checkId) return;
  return syncCheck(authId, checkId)
    .then(() => onClose?.())
    .catch(err => setErrorPopUp?.({ res: err.message }));
};
